import React from 'react';

export default function UnsplashIcon({color="#446372",width = "16px", height = "16px"}) {
  return (  
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3811_8274)">
        <rect width="16" height="16" fill="#BF2929" fill-opacity="0.01"/>
        <g clip-path="url(#clip1_3811_8274)">
          <path d="M16 7.0769V15.9979H0V7.0769H5.04025V11.5374H10.9597V7.0769H16ZM10.9598 0.000488281H5.04028V4.46099H10.9598V0.000488281Z" fill={color ? color : "#446372"} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3811_8274">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
        <clipPath id="clip1_3811_8274">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
